(() => {
  // Texte in der Sprache der Seite: window.cmT.search aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt search). Fehlt cmT
  // oder ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.search) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };
  class CompuMacSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[name="q"]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.all = this.querySelector('[data-search-all]');
      this.sequence = 0;
      this.active = -1;
      this.input.addEventListener('input', event => {
        this.invalidate();
        if (event.isComposing) return;
        this.schedule();
      });
      this.input.addEventListener('compositionend', () => { this.invalidate(); this.schedule(); });
      this.input.addEventListener('keydown', event => this.keydown(event));
      this.results.addEventListener('mousedown', event => { if (event.target.closest('a')) event.preventDefault(); });
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length > 1) this.schedule();
      });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.invalidate(); });
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
      });
    }
    disconnectedCallback() { this.invalidate(); }
    invalidate() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.sequence++;
      this.close();
      if (this.status) this.status.textContent = '';
      if (this.all) this.all.hidden = true;
    }
    close() {
      if (!this.input) return;
      this.results.hidden = true;
      this.results.replaceChildren();
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.removeAttribute('aria-busy');
      this.active = -1;
    }
    schedule() {
      clearTimeout(this.timer);
      const query = this.input.value.trim();
      if (query.length < 2) return;
      this.timer = setTimeout(() => this.suggest(query), 220);
    }
    async suggest(query) {
      const sequence = ++this.sequence;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 6000);
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = tx('loading', 'Suchvorschläge werden geladen …');
      const full = new URL(this.querySelector('form').action, window.location.origin);
      full.search = new URLSearchParams({q:query,type:'product,page,article','options[prefix]':'last'});
      this.all.href = full.href;
      this.all.hidden = false;
      const endpoint = new URL(this.dataset.url, window.location.origin);
      endpoint.search = new URLSearchParams({
        // Zehn holen, vier zeigen: sections/cm-search-suggestions.liquid ordnet die Produkte nach „neueste Generation zuerst“
        // (compuhub.generation_rank) und zeigt die ersten vier — aus vier Treffern ließe sich das neueste Gerät oft gar nicht wählen.
        q:query, 'resources[type]':'product,page,article', 'resources[limit]':'10',
        'resources[limit_scope]':'each', 'resources[options][unavailable_products]':'last',
        'resources[options][fields]':'title,product_type,variants.title,vendor,variants.sku,variants.barcode,body,tag',
        section_id:'cm-search-suggestions',
      });
      try {
        const editorial = window.cmEditorialSearch?.search(this.dataset.editorialIndex, query) || Promise.resolve([]);
        const [native, pages] = await Promise.allSettled([
          fetch(endpoint, {signal:controller.signal, credentials:'same-origin', cache:'no-store'}).then(response => {
            if (!response.ok) throw new Error('Search unavailable');
            return response.text();
          }), editorial,
        ]);
        if (sequence !== this.sequence || query !== this.input.value.trim()) return;
        const suggestions = new DOMParser().parseFromString(native.status === 'fulfilled' ? native.value : '<div data-cm-suggestions></div>', 'text/html').querySelector('[data-cm-suggestions]');
        if (!suggestions || (native.status === 'rejected' && (pages.status !== 'fulfilled' || !pages.value.length))) throw new Error('Search unavailable');
        if (pages.status === 'fulfilled' && pages.value.length) {
          let group = suggestions.querySelector('[role="group"][aria-label="Service & Informationen"]');
          if (!group) {
            group = document.createElement('div'); group.setAttribute('role', 'group'); group.setAttribute('aria-label', 'Service & Informationen');
            const title = document.createElement('p'); title.className = 'cm-search-group-title'; title.setAttribute('aria-hidden', 'true'); title.textContent = tx('pages_title_html', 'Service & Informationen'); group.append(title);
            suggestions.append(group);
          }
          const urls = new Set(pages.value.map(page => page.url));
          group.querySelectorAll('[role="option"]').forEach(option => {
            const link = option.querySelector('a');
            if (link && urls.has(new URL(link.getAttribute('href'), location.origin).pathname)) option.remove();
          });
          const anchor = group.querySelector('[role="option"]');
          pages.value.forEach(page => group.insertBefore(window.cmEditorialSearch.option(page), anchor));
          [...group.querySelectorAll('[role="option"]')].slice(4).forEach(option => option.remove());
        }
        this.results.replaceChildren(...suggestions.childNodes);
        const options = [...this.results.querySelectorAll('[role="option"]')];
        options.forEach((option, index) => { option.id = `${this.results.id}-${index}`; });
        this.results.hidden = options.length === 0;
        this.input.setAttribute('aria-expanded', String(options.length > 0));
        this.status.textContent = options.length ? (options.length === 1 ? tx('count_one', '{count} Vorschlag. Mit den Pfeiltasten auswählen oder alle Ergebnisse öffnen.', { count: options.length }) : tx('count_other', '{count} Vorschläge. Mit den Pfeiltasten auswählen oder alle Ergebnisse öffnen.', { count: options.length })) : tx('none', 'Keine direkten Vorschläge. Öffne alle Ergebnisse oder probiere einen anderen Begriff.');
        if (native.status === 'rejected') this.status.textContent += ' ' + tx('native_down', 'Die Produktsuche ist gerade nicht erreichbar; „Suchen“ öffnet die vollständige Suche.');
      } catch (error) {
        if (sequence !== this.sequence) return;
        this.close();
        this.status.textContent = tx('failed', 'Vorschläge sind gerade nicht verfügbar. Mit „Suchen“ öffnest du die vollständige Suche.');
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) this.removeAttribute('aria-busy');
      }
    }
    keydown(event) {
      if (event.isComposing) return;
      const options = [...this.results.querySelectorAll('[role="option"]')];
      if (event.key === 'Escape' && !this.results.hidden) { event.preventDefault(); this.invalidate(); return; }
      if (event.key === 'Enter' && this.active >= 0 && options[this.active]) {
        event.preventDefault(); options[this.active].querySelector('a').click(); return;
      }
      if (!['ArrowDown','ArrowUp'].includes(event.key) || !options.length || this.results.hidden) return;
      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      this.active = this.active < 0 ? (direction > 0 ? 0 : options.length - 1) : (this.active + direction + options.length) % options.length;
      options.forEach((option,index) => option.setAttribute('aria-selected', String(index === this.active)));
      this.input.setAttribute('aria-activedescendant', options[this.active].id);
      options[this.active].scrollIntoView({block:'nearest'});
    }
  }
  if (!customElements.get('cm-search')) customElements.define('cm-search', CompuMacSearch);

  let opener;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-search]');
    const dialog = document.getElementById('CMSearchDialog');
    if (trigger && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault(); opener = trigger; dialog.showModal(); dialog.querySelector('[name="q"]').focus();
    }
    if (event.target.closest('[data-close-search]')) dialog?.close();
  });
  const bindDialog = () => {
    const dialog = document.getElementById('CMSearchDialog');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => { dialog.querySelector('cm-search')?.invalidate(); opener?.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  };
  document.addEventListener('DOMContentLoaded', bindDialog);
  document.addEventListener('shopify:section:load', bindDialog);
  document.addEventListener('keydown', event => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k' && !event.altKey) {
      const trigger = document.querySelector('[data-open-search]');
      if (trigger) { event.preventDefault(); trigger.click(); }
    }
  });
})();
